import { cloneDeep } from 'lodash'

import { attach, services } from '@/utils'

import { userTariffsInputFilter, userTariffsOutputFilter } from '@/components/services/tariffs/utils'

export function inputFilter(result) {
  result.password = undefined

  if (result.referralCode === undefined) {
    result.referralCode = undefined
  }

  if (!result.data) {
    result.data = {}
  }

  if (result.data.firstName === undefined) {
    result.data.firstName = undefined
  }

  if (result.data.lastName === undefined) {
    result.data.lastName = undefined
  }

  // ResellerId
  if (!result.ResellerId) {
    result.ResellerId = result.Reseller?.id || null
  }

  // ManagerId
  if (!result.data.partnership?.ManagerId) {
    result.data.partnership.ManagerId = result.data.partnership?.Manager?.id || null
  }

  // Tariffs
  if (Array.isArray(result.Tariffs)) {
    result._Tariffs = cloneDeep(result.Tariffs)
    result.Tariffs = result.Tariffs
      .map(item => {
        return userTariffsInputFilter(item)
      })
      .sort((a, b) => {
        return a.priority - b.priority
      })
  } else {
    result.Tariffs = []
  }

  // RoutingGroups
  if (Array.isArray(result.RoutingGroups)) {
    const availableSendingTypeForRoutingGroups = {}
    for (const type of this.getSendingTypesByPermission(`advanced.${services.users}.setRoutingGroups`)) {
      availableSendingTypeForRoutingGroups[type] = []
    }
    result.RoutingGroups.sort((a, b) => {
      return (a.priority || 0) - (b.priority || 0)
    })
    result._RoutingGroups = result.RoutingGroups.map(item => {
      return {
        id: item.id,
        $attach: true
      }
    })
    result.RoutingGroups = result.RoutingGroups.reduce((result, group) => {
      if (group.priority === undefined) {
        group.priority = 0
      }
      if (!result[group.type]) {
        result[group.type] = []
      }
      result[group.type].push({ id: group.id })

      return result
    }, availableSendingTypeForRoutingGroups)
  } else {
    result.RoutingGroups = {}
  }

  const availableSendingType = {}
  for (const type of this.getSendingTypesByPermission(`advanced.${services.users}.update`)) {
    availableSendingType[type] = []
  }

  // Sendernames
  if (Array.isArray(result.Sendernames)) {
    result._Sendernames = cloneDeep(result.Sendernames)
    result.Sendernames = result.Sendernames.reduce((result, { id, type }) => {
      if (!result[type]) {
        result[type] = []
      }
      result[type].push(id)

      return result
    }, cloneDeep(availableSendingType))
  } else {
    result.Sendernames = []
  }

  // Patterns
  if (Array.isArray(result.Patterns)) {
    result._Patterns = cloneDeep(result.Patterns)
    result.Patterns = result.Patterns.reduce((result, { id, type }) => {
      if (!result[type]) {
        result[type] = []
      }
      result[type].push(id)

      return result
    }, cloneDeep(availableSendingType))
  } else {
    result.Patterns = []
  }

  // MessageRuleGroups
  if (Array.isArray(result.MessageRuleGroups)) {
    result._MessageRuleGroups = cloneDeep(result.MessageRuleGroups)
    result.MessageRuleGroups = result.MessageRuleGroups.map(item => {
      return {
        id: item.id,
        priority: item.priority,
        $attach: true
      }
    }).sort((a, b) => {
      return (a.priority || 0) - (b.priority || 0)
    })
  } else {
    result.MessageRuleGroups = []
  }

  // Meta
  if (!result.data.meta) {
    result.data.meta = {}
  }

  // UsedReferralCode
  if (result.data.meta.usedReferralCode === undefined) {
    result.data.meta.usedReferralCode = undefined
  }

  return result
}

export function outputFilter(result) {
  if (!result.ResellerId) {
    result.ResellerId = null
  }
  delete result.Reseller

  if (!result.data.partnership.ManagerId) {
    result.data.partnership.ManagerId = null
  }
  delete result.data.partnership.Manager

  result.RoutingGroups = Object.keys(result.RoutingGroups).reduce((groups, type) => {
    const group = result.RoutingGroups[type]
    for (let index = 0; index < group.length; index++) {
      const { id } = group[index]
      groups.push({
        id,
        priority: index,
        $attach: true
      })
    }

    return groups
  }, [])
  attach(result, 'RoutingGroups')

  result.Tariffs = result.Tariffs
    .map(item => {
      return userTariffsOutputFilter(item)
    })
    .sort((a, b) => {
      return a.priority - b.priority
    })
  attach(result, 'Tariffs')

  const Sendernames = []
  for (const sendingType in result.Sendernames) {
    for (const id of result.Sendernames[sendingType]) {
      if (!~Sendernames.findIndex(sendername => {
        return sendername.id === id
      })) {
        Sendernames.push({
          id,
          $attach: true
        })
      }
    }
  }
  result.Sendernames = Sendernames
  attach(result, 'Sendernames')

  const Patterns = []
  for (const sendingType in result.Patterns) {
    for (const id of result.Patterns[sendingType]) {
      if (!~Patterns.findIndex(pattern => {
        return pattern.id === id
      })) {
        Patterns.push({
          id,
          $attach: true
        })
      }
    }
  }
  result.Patterns = Patterns
  attach(result, 'Patterns')

  if (Array.isArray(result.MessageRuleGroups)) {
    result.MessageRuleGroups = result.MessageRuleGroups.map((item, index) => {
      return {
        id: item.id,
        priority: index,
        $attach: true
      }
    }).sort((a, b) => {
      return (a.priority || 0) - (b.priority || 0)
    })
    attach(result, 'MessageRuleGroups')
  } else {
    result.MessageRuleGroups = undefined
  }

  delete result.balance
  delete result.$verified
  delete result.settings
  delete result.permissions
  delete result.createdAt
  delete result.updatedAt

  return result
}
